import { render } from "./AccountsPayable.vue?vue&type=template&id=dd76a4a6&scoped=true"
import script from "./AccountsPayable.vue?vue&type=script&lang=js"
export * from "./AccountsPayable.vue?vue&type=script&lang=js"

import "./AccountsPayable.vue?vue&type=style&index=0&id=dd76a4a6&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd76a4a6"]])

export default __exports__